export function loadWorkbenchMonitor() {
  return import("@/pages/StrategyCenter").then((module) => ({
    default: module.StrategyCenter,
  }));
}
